import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as zxcvbn from 'zxcvbn';

@Component({
  selector: 'app-password-strength-meter',
  templateUrl: './password-strength-meter.component.html',
  styleUrls: ['./password-strength-meter.component.scss']
})
export class PasswordStrengthMeterComponent {
  @Input() newPassword: string = '';
  passwordStrength = 0; // zxcvbn score ranges from 0 to 4
  passwordWarning = '';
  passwordStrengthText = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.newPassword) {
      this.evaluatePasswordStrength(changes.newPassword.currentValue);
    }
  }

  evaluatePasswordStrength(password: string) {
    const result = zxcvbn(password);
    this.passwordStrength = result.score;
    this.passwordStrengthText = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'][this.passwordStrength];
    this.passwordWarning = result.feedback.warning || '';
  }
}
